import { Injectable } from '@angular/core';

import { IOutcome } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { ITeamsScores } from '../../../core/models/team.model';

@Injectable({ providedIn: 'root' })
export class ScoreMarketBaseService {
    /**
     * getMaxScoreValues()
     * @param {IOutcome[]} outcomes
     * @returns {Object}
     */
    getMaxScoreValues(outcomes: IOutcome[]): ITeamsScores {
        const homeScores = this.getNumbers(outcomes || [], 0);
        const awayScores = this.getNumbers(outcomes || [], 1);

        // fix when no outcomes with 0 count, we need to start counter from 0 to handle up/down score switch
        if (homeScores.indexOf(0) === -1) {
            homeScores.unshift(0);
        }
        if (awayScores.indexOf(0) === -1) {
            awayScores.unshift(0);
        }

        return {
            teamA: awayScores,
            teamH: homeScores,
        };
    }

    /**
     * getNumbers()
     * @param {IOutcome[]} outcomesList
     * @param {number} index
     * @returns {number[]}
     */
    private getNumbers(outcomesList: IOutcome[], index: number): number[] {
        if (!outcomesList || !outcomesList.length) {
            return [0];
        }

        return _.uniq(
            _.map(outcomesList, (outcome) => {
                const scores = outcome?.outcomeMeaningScores?.split(',') ?? [];
                const value = scores[index];
                return value !== undefined && value.trim() !== '' && !isNaN(Number(value)) ? Number(value) : null;
            })
                .filter((v): v is number => v !== null)
                .sort((a, b) => a - b),
        );
    }
}
